<!-- svelte-ignore a11y-missing-attribute -->
<img src="/static/cross_country_optimized2.svg" />
